import * as Yup from "yup";
import styled from "styled-components/macro";
import { Box, List, ListItem, Typography } from "@mui/material";
import { Check, Clear } from "@mui/icons-material";
import React from "react";
import TextField from "../../../../../components/custom/TextField";
import { useTranslation } from "react-i18next";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import InfoIcon from "@mui/icons-material/Info";

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    width: 300,
    // height: 140,
    height: (props) => 100 * props.ratio,
    border: "1px solid #dadde9",
    borderRadius: "1rem",
    margin: 0,
    display: "flex",
    flexDirection: "column",
  },
}));

const ListWrapper = styled(List)`
  height: 20%;
  padding: 0;
  li {
    padding: 0;
  }
  margin-left: 1rem;
`;

const ListItemsWrapper = styled(Box)`
  display: flex;
  align-items: center;
`;
const CheckIconWrapper = styled(Check)`
  margin-left: 0.3rem;
  font-size: 0.8rem;
  color: green;
`;

const ClearIconWrapper = styled(Clear)`
  margin-left: 0.3rem;
  font-size: 0.8rem;
  color: red;
`;

const LabelWrapper = styled(Box)`
  display: flex;
  align-items: center;
`;

const EightChars = /.{8,}/;
const UpperCaseCharacter = /(.*[A-Z].*)/;
const LowerCaseCharacter = /(.*[a-z].*)/;
const AtLeastOneDigit = /(.*\d.*)/;
const SpecialCharacter = /(.*\W.*)/;

function RegistrationDetails(props) {
  const { values } = props;
  const { t } = useTranslation();
  return (
    <Box sx={{ m: 2 }}>
      <TextField
        label={<Typography variant="h6">{t("Email")}</Typography>}
        placeholder={t("Your email")}
        margin="normal"
        name="userEmail"
        type="email"
      />
      <TextField
        label={
          <LabelWrapper>
            <Typography variant="h6">{"Password"}</Typography>
            <HtmlTooltip
              placement="right-end"
              title={
                <>
                  <Typography sx={{ fontSize: "0.7rem", fontWeight: "600" }}>
                    {t("Password should contain")}
                  </Typography>
                  <ListWrapper sx={{ listStyleType: "disc" }}>
                    <ListItem sx={{ display: "list-item" }}>
                      <ListItemsWrapper>
                        {t("At least 8 characters")}
                        {values?.userPassword?.match(EightChars) ? (
                          <CheckIconWrapper />
                        ) : (
                          <ClearIconWrapper />
                        )}
                      </ListItemsWrapper>
                    </ListItem>
                    <ListItem sx={{ display: "list-item" }}>
                      <ListItemsWrapper>
                        {t("At least one upper case letter")}
                        {values?.userPassword?.match(UpperCaseCharacter) ? (
                          <CheckIconWrapper />
                        ) : (
                          <ClearIconWrapper />
                        )}
                      </ListItemsWrapper>
                    </ListItem>
                    <ListItem sx={{ display: "list-item" }}>
                      <ListItemsWrapper>
                        {t("At least one lower case letter")}
                        {values?.userPassword?.match(LowerCaseCharacter) ? (
                          <CheckIconWrapper />
                        ) : (
                          <ClearIconWrapper />
                        )}
                      </ListItemsWrapper>
                    </ListItem>
                    <ListItem sx={{ display: "list-item" }}>
                      <ListItemsWrapper>
                        {t("At least one digit")}
                        {values?.userPassword?.match(AtLeastOneDigit) ? (
                          <CheckIconWrapper />
                        ) : (
                          <ClearIconWrapper />
                        )}
                      </ListItemsWrapper>
                    </ListItem>
                    <ListItem sx={{ display: "list-item" }}>
                      <ListItemsWrapper>
                        {t("At least one special character (Ex. !@#$%)")}
                        {values?.userPassword?.match(SpecialCharacter) ? (
                          <CheckIconWrapper />
                        ) : (
                          <ClearIconWrapper />
                        )}
                      </ListItemsWrapper>
                    </ListItem>
                  </ListWrapper>
                </>
              }
            >
              <InfoIcon sx={{ ml: 2, fontSize: "1.3rem" }} />
            </HtmlTooltip>
          </LabelWrapper>
        }
        placeholder={t("Your password")}
        margin="normal"
        name="userPassword"
        type="password"
      />
      <TextField
        label={<Typography variant="h6">{t("Retype password")}</Typography>}
        placeholder={t("Retype password")}
        margin="normal"
        name="userPassword2"
        type="password"
      />
      <TextField
        label={<Typography variant="h6">{t("First Name")}</Typography>}
        placeholder={t("Your first name")}
        margin="normal"
        name="userFirstName"
      />
      <TextField
        label={<Typography variant="h6">{t("Last Name")}</Typography>}
        placeholder={t("Your last name")}
        margin="normal"
        name="userLastName"
      />
      <TextField
        label={<Typography variant="h6">{t("Address")}</Typography>}
        placeholder={t("Your address details")}
        margin="normal"
        name="userAddress"
      />
      <TextField
        label={<Typography variant="h6">{t("Compay Name")}</Typography>}
        placeholder={t("Your company name")}
        margin="normal"
        name="userCompanyName"
      />
    </Box>
  );
}

RegistrationDetails.label = "User account";

RegistrationDetails.initialValues = {
  userEmail: "",
  userPassword: "",
  userPassword2: "",
  userFirstName: "",
  userLastName: "",
  userAddress: "",
  userCompanyName: "",
};

RegistrationDetails.validationSchema = Yup.object().shape({
  userFirstName: Yup.string().required("Please enter your first Name"),
  userLastName: Yup.string().required("Please enter your last Name"),
  userPassword: Yup.string().required("Please enter your password"),
  userPassword2: Yup.string()
    .required("Please retype your password")
    .oneOf([Yup.ref("userPassword"), null], "Passwords must match"),
  userEmail: Yup.string()
    .email("Invalid Email")
    .required("Please enter your email"),
  userAddress: Yup.string().required("Please enter your address"),
  userCompanyName: Yup.string().required("Please enter your company name"),
});

export default RegistrationDetails;
